import { useAppSelector } from '../../../reducers';
import { isUngatedForInbound25Selector, isUngatedForSeatsSelector } from '../../../selectors/GatingSelectors';
import { skuSelector } from '../../../selectors/ProductsSelectors';
import IncludedContacts from './IncludedContacts';
import { IncludedUsersPreSeats } from './IncludedUsersPreSeats';
import { Flex } from 'foundations-components/components/Flex';
import IncludedHubspotCredits from './IncludedHubspotCredits';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const SubtextDisplayContainer = ({
  additionalUnitSkuId,
  queryParamTerm,
  productLine,
  productLevel,
  includedProductLevelHubspotCredits
}) => {
  const isSeatsRedesignUngated = useAppSelector(isUngatedForSeatsSelector);
  const isUngatedForInbound25 = useAppSelector(isUngatedForInbound25Selector);
  const quantityPack = useAppSelector(state => {
    if (!additionalUnitSkuId) {
      return null;
    }
    return skuSelector(state, {
      skuId: additionalUnitSkuId
    });
  });
  const quantityPackApiName = quantityPack === null || quantityPack === void 0 ? void 0 : quantityPack.quantityPackApiName;
  const includedWithProductVersion = quantityPack === null || quantityPack === void 0 ? void 0 : quantityPack.includedWithProductVersion;
  if ((quantityPackApiName === 'additional-sales-seats' || quantityPackApiName === 'additional-service-seats') && !isSeatsRedesignUngated && includedWithProductVersion) {
    return /*#__PURE__*/_jsx(IncludedUsersPreSeats, {
      productLine: productLine,
      productLevel: productLevel,
      includedWithProductVersion: includedWithProductVersion
    });
  } else if ((quantityPackApiName === 'additional-marketing-contacts' || quantityPackApiName === 'additional-legacy-contacts') && includedWithProductVersion) {
    return /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      gap: "0",
      children: [isUngatedForInbound25 && /*#__PURE__*/_jsx(IncludedHubspotCredits, {
        includedProductLevelHubspotCredits: includedProductLevelHubspotCredits
      }), /*#__PURE__*/_jsx(IncludedContacts, {
        additionalUnitSkuId: additionalUnitSkuId,
        queryParamTerm: queryParamTerm,
        productLine: productLine,
        productLevel: productLevel,
        includedWithProductVersion: includedWithProductVersion
      })]
    });
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: isUngatedForInbound25 ? /*#__PURE__*/_jsx(IncludedHubspotCredits, {
      includedProductLevelHubspotCredits: includedProductLevelHubspotCredits
    }) : null
  });
};